/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Qc_Fix_Leading_Trailing_SpaceInputs */



/**
* | output |
* | --- |
* | "Leading/trailing spaces" |
*
* @param {Qc_Fix_Leading_Trailing_SpaceInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const qc_fix_leading_trailing_space = /** @type {((inputs?: Qc_Fix_Leading_Trailing_SpaceInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Qc_Fix_Leading_Trailing_SpaceInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Espaces en début/fin")
	if (locale === "de") return /** @type {LocalizedString} */ ("Führende/nachgestellte Leerzeichen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Spazi iniziali/finali")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Пробелы в начале/конце")
	if (locale === "es") return /** @type {LocalizedString} */ ("Espacios al inicio/final")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("开头/结尾空格")
	if (locale === "ja") return /** @type {LocalizedString} */ ("先頭/末尾のスペース")
	if (locale === "hi") return /** @type {LocalizedString} */ ("आरंभ/अंत के रिक्त स्थान")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Espaços no início/fim")
	return /** @type {LocalizedString} */ ("Leading/trailing spaces")
});